import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Socket } from 'ngx-socket-io';

@Component({
  selector: 'app-front-action',
  templateUrl: './front-action.component.html',
  styleUrls: ['./front-action.component.scss']
})
export class FrontActionComponent implements OnInit {

  public company_uuid;
  public is_loading = false;
  public status = 'pending';
  public type = 'bank';
  public collection : any = [];
  public bank : any = [];
  public submitted = false;
  constructor(private http: HttpService, private socket: Socket) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

  ngOnInit(): void {
    this.load()

    this.socket.on("admin-notify", (data) => {

      if(this.status == "pending") {
        this.load();
      };
      
    })
  }

  async action(status, type) {
    this.status = status;
    this.type = type;
    this.is_loading = true;
    await this.load();
  }

  async load() {
    this.collection = []
    const data : any = {
      status: this.status,
      type: this.type
    }
    const t:any = await this.http.post("/admin/action/get", data);
    this.collection = t.collection
    this.bank = t.bank;
    this.is_loading = false

  }

  async update(id, status, other) {

    this.submitted = true;
    const data : any = {
      status: status,
      id: id,
      other
    }

    const s:any = await this.http.post("/admin/action/update", data);

    if (s.status) {
      await this.load();
      this.submitted = false;
    } else {
      this.http.notify(s.message)
      this.submitted = false;
    }
  }

  tanslateStatus(status) {
    switch(status) {
      case 1:
        return "complete"
      case 2:
        return "pending"
      case 0:
        return "cancel"
    }
  }

  tanslatePlayerStatus(status) {
    switch(status) {
      case 1:
        return "Active"
      case 0:
        return "Disabled"
    }
  }

  viewSlip(image) {
    var win : any = window.open("about:blank",'_blank', "height=800,width=600");
    win.document.write('<img src="' + image + '"style="width:100%"></img>');
  }
  
}